import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import MuiAppBar from '@mui/material/AppBar';
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useLogout } from "./Authentication";

const drawerWidth = 240;

const AppBarStyled = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

const AppBar = ({ open, toggleDrawer }) => {
    const Logout = useLogout();

    return (
    <AppBarStyled position="absolute" open={open}>
        <Toolbar
        sx={{
            pr: "24px", // keep right padding when drawer closed
        }}
        >
        <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={(toggleDrawer)}
            sx={{
            marginRight: "36px",
            ...(open && { display: "none" }),
            }}
        >
            <MenuIcon />
        </IconButton>
        <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            sx={{ flexGrow: 1 }}
        >
            Renox Assistant Console
        </Typography>
        <IconButton color="inherit" onClick={ Logout }>
            <LogoutIcon />
        </IconButton>
        {/* Add other AppBar elements here */}
        </Toolbar>
    </AppBarStyled>
    );
}

export default AppBar;